export const updateProfileImage = (imageUrl) => ({
  type: 'UPDATE_PROFILE_IMAGE',
  payload: imageUrl,
});

// export const updateLanguage = (code) => ({
//   type: 'UPDATE_LANGAUGE',
//   payload: { code: code },
// });

export const updateLanguage = (data) => ({
  type: 'UPDATE_LANGAUGE',
  payload: data,
});

export const updateQuestionFiltes = (data) => ({
  type: 'UPDATE_QUESTION_FILTERS',
  payload: data,
});

export const updatePaginationSize = (data) => ({  
  type: 'UPDATE_PAGINATION_SIZE',
  payload: data
});

